/**
 * Gallery Images Data
 * Author: MCGdev
 * 
 * All images are served from public/assets/ for better performance
 * Using direct paths instead of imports for smaller bundle size
 */

export const galleryImages = [
  // Shop and Professional Work
  { 
    src: "/assets/shop-juston-rosariobatangas.PNG", 
    webp: "/assets/shop-juston-rosariobatangas.webp",
    alt: "Just One Computer Repair shop exterior in Rosario, Batangas", 
    caption: "Trusted computer repair shop in Rosario, Batangas",
    category: "shop",
    icon: "Storefront"
  },
  { 
    src: "/assets/professional-repair-motherboard.PNG", 
    webp: "/assets/professional-repair-motherboard.webp",
    alt: "Professional technician repairing computer motherboard", 
    caption: "Expert motherboard repair with certified techniques",
    category: "repair",
    icon: "Wrench"
  },
  { 
    src: "/assets/juston-repair-electronic.PNG", 
    webp: "/assets/juston-repair-electronic.webp",
    alt: "Electronic component repair and diagnosis", 
    caption: "Advanced electronic component diagnosis & repair",
    category: "repair",
    icon: "Lightning"
  },

  // Gaming PC Services
  { 
    src: "/assets/gaming-pcbuild-justone-rosario-batangas.jpeg", 
    webp: "/assets/gaming-pcbuild-justone-rosario-batangas.webp",
    alt: "Custom gaming PC build completed for client", 
    caption: "Custom gaming PC with premium components",
    category: "gaming",
    icon: "GameController"
  },
  { 
    src: "/assets/gamingpc-build-rosario-justone.jpeg", 
    webp: "/assets/gamingpc-build-rosario-justone.webp",
    alt: "Gaming PC interior with RGB lighting and custom cooling", 
    caption: "High-performance gaming PC with RGB lighting",
    category: "gaming",
    icon: "Lightbulb"
  },
  { 
    src: "/assets/juston.gamingpc.repair.PNG", 
    webp: "/assets/juston.gamingpc.repair.webp",
    alt: "Gaming PC assembly and testing in progress", 
    caption: "Professional gaming PC assembly & testing",
    category: "gaming",
    icon: "Hammer"
  },
  { 
    src: "/assets/gaming-pc-custom-repair-build.jpg", 
    webp: "/assets/gaming-pc-custom-repair-build.webp",
    alt: "Custom gaming PC repair and build service", 
    caption: "Custom gaming PC repair & build",
    category: "gaming",
    icon: "GameController"
  },

  // Laptop Repair Services
  { 
    src: "/assets/justone-laptop-repair-rosario-batangas.jpeg", 
    webp: "/assets/justone-laptop-repair-rosario-batangas.webp",
    alt: "Laptop repair service in Rosario, Batangas", 
    caption: "Complete laptop repair services in Rosario, Batangas",
    category: "laptop",
    icon: "Laptop"
  },
  { 
    src: "/assets/laptop-repair-justone-rosario.jpeg", 
    webp: "/assets/laptop-repair-justone-rosario.webp",
    alt: "Disassembled laptop components ready for repair", 
    caption: "Precision laptop disassembly & diagnosis",
    category: "laptop",
    icon: "MagnifyingGlass"
  },
  { 
    src: "/assets/laptop-repair-rosario.jpeg", 
    webp: "/assets/laptop-repair-rosario.webp",
    alt: "Laptop repair workspace with tools and components", 
    caption: "Fully equipped laptop repair workstation",
    category: "laptop",
    icon: "Toolbox"
  },
  { 
    src: "/assets/laptop-repair-maintenance.jpg", 
    webp: "/assets/laptop-repair-maintenance.webp",
    alt: "Laptop repair and maintenance service", 
    caption: "Complete laptop repair & maintenance",
    category: "laptop",
    icon: "Laptop"
  },

  // Printer Repair Services
  { 
    src: "/assets/printer-repair-rosario-batangas-justone.jpeg", 
    webp: "/assets/printer-repair-rosario-batangas-justone.webp",
    alt: "Printer repair service by Just One technician", 
    caption: "Expert printer repair for all major brands",
    category: "printer",
    icon: "Printer"
  },
  { 
    src: "/assets/brokenprinter-repair-rosario-batangas-justone.jpeg", 
    webp: "/assets/brokenprinter-repair-rosario-batangas-justone.webp",
    alt: "Broken printer being repaired by expert technician", 
    caption: "Complete printer restoration service",
    category: "printer",
    icon: "Wrench"
  },
  { 
    src: "/assets/printer-repair-rosario.jpeg", 
    webp: "/assets/printer-repair-rosario.webp",
    alt: "Printer troubleshooting and repair process", 
    caption: "Advanced printer troubleshooting & repair",
    category: "printer",
    icon: "Gear"
  },
  { 
    src: "/assets/printer-diagnostic-repair.jpg", 
    webp: "/assets/printer-diagnostic-repair.webp",
    alt: "Printer diagnostic and repair service", 
    caption: "Expert printer diagnostics & repair",
    category: "printer",
    icon: "Printer"
  },

  // PC Hardware Services
  { 
    src: "/assets/pc-repair-cpu-rosario-justone.jpeg", 
    webp: "/assets/pc-repair-cpu-rosario-justone.webp",
    alt: "CPU thermal paste application and cooling system repair", 
    caption: "Professional CPU thermal management & cooling",
    category: "hardware",
    icon: "Thermometer"
  },
  { 
    src: "/assets/pc-repair-rosario-batangas-justone.jpeg", 
    webp: "/assets/pc-repair-rosario-batangas-justone.webp",
    alt: "PC hardware diagnosis and repair in Rosario, Batangas", 
    caption: "Comprehensive PC hardware diagnosis & repair",
    category: "hardware",
    icon: "Desktop"
  },
  { 
    src: "/assets/pc-school-repair.jpeg", 
    webp: "/assets/pc-school-repair.webp",
    alt: "School computer lab setup and maintenance", 
    caption: "Educational institution computer support",
    category: "institutional",
    icon: "GraduationCap"
  },
  { 
    src: "/assets/pc-school-repair-maintenance.jpg", 
    webp: "/assets/pc-school-repair-maintenance.webp",
    alt: "PC repair and maintenance for schools", 
    caption: "Reliable PC repair and maintenance services for schools",
    category: "institutional",
    icon: "GraduationCap"
  }
];

export const aboutImage = {
  src: "/assets/about-us-just-one-juston.jpg",
  webp: "/assets/about-us-just-one-juston.webp",
};

export default galleryImages;
